import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { register } from './serviceWorkerRegistration';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registers the service worker (sw.js in /public).
// On first visit: caches the app shell and static assets.
// On repeat visits: serves from cache instantly, then checks for updates.
register();

reportWebVitals();